(ns ycweb.components.feedback
  (:require
   [rum.core :as rum]
   [ycweb.util.core :as u]))

(rum/defc feedback-raw < rum/reactive
  [feedback-type {:keys [title description message custom close-atom type-class size shadow] :as options}]
  (if (and close-atom (rum/react close-atom))
    [:span]
    [:div
     {:role "alert"
      :class [(u/bem :feedback [feedback-type (when type-class type-class) (when size size) (when shadow :has-shadow)])]}
     [:div.feedback__icon [:i {:class (u/bem :icon [feedback-type :block])}]]
     [:div.feedback__content
      (cond
        (u/presence message)
        [:div.feedback__message message]

        :else
        [:div
         [:h4.feedback__title title]
         (when (u/presence description) [:p.feedback__description description])])

      custom]
     (when close-atom
       [:a.feedback__close-button.js-feedback-close-button
        {:on-click #(reset! close-atom true)}
        [:i
         {:class (u/bem :icon [:close :block])}
         [:span.u-hidden-from-view "Close this notification"]]])]))

(defn feedback [feedback-type title & [description close-atom type-class size message]]
  (feedback-raw feedback-type
    {:title title
     :description description
     :close-atom close-atom
     :type-class type-class
     :size size
     :message message}))

(rum/defc action-feedback < rum/reactive
  [feedback-type title description check-atom {:keys [subtext smaller reverse-content]}]
  [:label
   {:on-click #(swap! check-atom not)
    :class
    (u/bem :feedback
      [:has-checkbox :info
       (when subtext :is-multiline)
       (when smaller :smaller)
       (when (rum/react check-atom) :is-checked)])}
   [:div.feedback__icon [:i {:class (u/bem :icon [feedback-type :block])}]]
   [:div.feedback__content
    (into
      [:div.feedback__content]
      [(into
         (if subtext [:h4.feedback__title] [])
         (if reverse-content
           [title " " [:b description]]
           [[:b title] " " description]))
       (when subtext
         [:p.feedback__description subtext])])]
   [:div.feedback__checkbox
    [:div.checkbox-label
     [:input.checkbox
      {:type "checkbox",
       :name "radio",
       :checked (boolean (rum/react check-atom))
       :value 1
       :on-change #(swap! check-atom not)}]
     [:span.checkbox__graphic-wrapper [:span.checkbox__graphic]]]]])

(rum/defcs feedback-demo < (rum/local {} ::state) [s]
  (let [local-atom (::state s)]

    [:div
     [:h2.u-margin-top-24
      {:class (u/bem :heading [:large])}
      "Basic Feedback Blocks:"]

     (feedback :info "This is the title" "This is the description")
     (feedback :success "This is the title" "This is the description")
     (feedback :warning "This is the title" "This is the description")
     (feedback :error "This is the title" "This is the description")


     [:h2.u-margin-top-24
      {:class (u/bem :heading [:large])}
      "Closeable Feedback Blocks:"]


     (feedback :info "This is the title" "This is the description"
       (rum/cursor local-atom :info-closed))


     (feedback :success "This is the title" "This is the description"
       (rum/cursor local-atom :success-closed))


     (feedback :warning "This is the title" "This is the description"
       (rum/cursor local-atom :warning-closed))


     (feedback :error "This is the title" "This is the description"
       (rum/cursor local-atom :error-closed))


     [:h2.u-margin-top-24
      {:class (u/bem :heading [:large])}
      "Feedback Blocks Require Action:"]


     (action-feedback :location
       "A Single Line:" "Take Action" (rum/cursor local-atom :action-checked) {})]))